import React from 'react';
import { useTranslation } from 'react-i18next';

function HeroSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n?.language || '').toLowerCase();
  const isArabic = lang.startsWith('ar');
  const isPersian = lang.startsWith('fa') || lang.startsWith('ir') || lang.includes('persian');
  return (
    <section className="w-full bg-slate-50 dark:bg-slate-900 pt-24" dir={isArabic || isPersian ? 'rtl' : 'ltr'}>
      <div className="mx-auto max-w-7xl px-6 py-24 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left content */}
        <div>
          <h3 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-slate-100 mb-5 leading-tight">
            {t('heroSection.title', 'Empowering the Future of Intelligent Organizations')}
          </h3>
          <p className="text-slate-600 dark:text-slate-300 text-base md:text-lg leading-7 mb-8">
            {t(
              'heroSection.description',
              'We are an AI Solution Provider transforming how organizations think, work, and grow through intelligent, modular AI assistants. Our solutions elevate human potential and enable autonomous operations for seamless human–AI collaboration.'
            )}
          </p>

          <div className="flex gap-3">
            <a
              href="https://smartorg.demisco.ai/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 no-underline rounded-full px-5 py-3 text-sm font-semibold bg-blue-600 text-white hover:bg-blue-700 transition-colors"
            >
              {t('heroSection.getStarted', 'Get started')}
              <span>→</span>
            </a>
          </div>

          {/* <div className="flex flex-wrap gap-3">
            <button className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold bg-blue-600 text-white hover:bg-blue-700 transition-colors">
              What's new
              <span className="text-white">→</span>
            </button>
            <button className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold border border-slate-300 text-slate-900 bg-white hover:bg-slate-50 dark:border-slate-600 dark:text-slate-100 dark:bg-slate-800 dark:hover:bg-slate-700 transition-colors">
              Try it free
              <span>→</span>
            </button>
          </div> */}
        </div>

        {/* Right Hero Section */}
        <div className="relative">
          <div className="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-xl overflow-hidden">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-auto"
              poster="/assets/images/loading/Hero_loading.PNG"
            >
              <source src="/assets/video/Hero.mp4" type="video/mp4" />
            </video>
          </div>

          {/* Floating logos */}
          {/* <div className="pointer-events-none select-none">
            <div className="absolute -top-6 -left-4 size-10 rounded-xl bg-slate-100 dark:bg-slate-700 shadow" />
            <div className="absolute -top-10 right-6 size-10 rounded-xl bg-slate-100 dark:bg-slate-700 shadow" />
            <div className="absolute -bottom-8 left-8 size-10 rounded-xl bg-slate-100 dark:bg-slate-700 shadow" />
            <div className="absolute -bottom-10 -right-4 size-10 rounded-xl bg-slate-100 dark:bg-slate-700 shadow" />
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default HeroSection;


